import { render, staticRenderFns } from "./UsingToken.vue?vue&type=template&id=3f92f77b&scoped=true&"
import script from "./UsingToken.vue?vue&type=script&lang=js&"
export * from "./UsingToken.vue?vue&type=script&lang=js&"
import style0 from "./UsingToken.vue?vue&type=style&index=0&id=3f92f77b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.10.1_y5o36p7qrshhm4v7l6yk7rwfsu/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f92f77b",
  null
  
)

export default component.exports